module.exports = __webpack_public_path__ + "static/media/Sudden.6f4b738b.png";